// extracted by mini-css-extract-plugin
module.exports = {"list":"PrefectureList_list__NKkMC","item":"PrefectureList_item__Zxxff","link":"PrefectureList_link__HnaC2","name":"PrefectureList_name__uVmn5"};